import StoreProvider from "@shared/StoreProvider";
import LeadIndexDynamic from "./pages/LeadIndexDynamic";

export default () => (
  <StoreProvider>
    <LeadIndexDynamic />
  </StoreProvider>
);
